import React from 'react';
import { filterProps } from './props';
export const omitProps = (componentFn, omitProps = []) => /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const restProps = !omitProps?.length ? props : filterProps(props, key => !omitProps.includes(key));
  return componentFn(restProps, forwardedRef);
});
export const withOmitProps = (omitProps = []) => ({
  shouldForwardProp: prop => !omitProps.includes(prop)
});